import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { AppSettings } from './modules/shared/app.settings';
import { Router } from '@angular/router';
import { UserCommonService } from './modules/shared/services/user-common.service';
import { NotificationsService } from './modules/shared/services/notifications.service';
import { MessagingService } from './service/messaging.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {

  showHeaderAndSidebar = false;
  message: any;
  token: any;
  isDashboardPage = false;

  constructor(
    private router: Router,
    private titleService: Title,
    public notificationService: NotificationsService,
    public userCommonService: UserCommonService,
    private messagingService: MessagingService
  ) {
    this.router.events.subscribe((currentPath: any) => {
      if (currentPath && currentPath.url !== undefined && currentPath.url !== null) {
        const browserUrl = currentPath.url.split('?');
        this.isDashboardPage = browserUrl[0].includes('/admin-dashboard');
        // Show / hide header & sidebar
        if (AppSettings.HEADER_NOT_REQUIRED.includes(browserUrl[0])) {
          this.showHeaderAndSidebar = false;
        } else {
          this.showHeaderAndSidebar = true;
        }

        // Update page title based on current route
        const path = browserUrl[0] || '';
        const cleanedPath = path.replace(/^\//, '');
        let pageTitle = 'Dashboard';

        if (cleanedPath) {
          const segments = cleanedPath.split('/');
          const lastSegment = segments[segments.length - 1];
          const secondLastSegment = segments[segments.length - 2];
          if (secondLastSegment) {
            const SecondlastSegmentTitle = secondLastSegment
            .replace(/-/g, ' ')
            .replace(/\b\w/g, (char: string) => char.toUpperCase());
            pageTitle =
            SecondlastSegmentTitle +
              ' | ' +
              lastSegment
                .replace(/-/g, ' ')
                .replace(/\b\w/g, (char: string) => char.toUpperCase());
          } else {
            pageTitle = lastSegment
              .replace(/-/g, ' ')
              .replace(/\b\w/g, (char: string) => char.toUpperCase());
          }
        }

        this.titleService.setTitle(`Mobisoft - ${pageTitle}`);
      }
    });
  }

  ngOnInit() {
    this.messagingService.requestPermission();
    this.messagingService.receiveMessage();
    this.message = this.messagingService.currentMessage;
    this.token = this.messagingService.browserToken;
    
  }
}
